import { c as _c } from "react/compiler-runtime";
import { trackEvent } from "@justhome/common";
import { CardButton as BaseCardButton } from "@justhome/react-ui";
import { ComponentBlocksCardButton } from "@lib/generated/graphql";
import { getPageEntityPath } from "@lib/routing";
import { FC } from "react";
export const Button: FC<ComponentBlocksCardButton & {
  className?: string;
  testId?: string;
}> = t0 => {
  const $ = _c(21);
  const {
    title,
    variant,
    body,
    footer,
    href,
    page,
    className,
    trackingId,
    testId
  } = t0;
  let t1;
  if ($[0] !== href || $[1] !== page) {
    t1 = getPageEntityPath(page) ?? href;
    $[0] = href;
    $[1] = page;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const pageHref = t1;
  let t2;
  if ($[3] !== trackingId) {
    t2 = () => {
      if (trackingId) {
        trackEvent(trackingId);
      }
    };
    $[3] = trackingId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClickCardButton = t2;
  const t3 = trackingId || undefined;
  let t4;
  if ($[5] !== title) {
    t4 = <BaseCardButton.Title>{title}</BaseCardButton.Title>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== body) {
    t5 = <BaseCardButton.Body>{body}</BaseCardButton.Body>;
    $[7] = body;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== footer) {
    t6 = <BaseCardButton.Footer>{footer}</BaseCardButton.Footer>;
    $[9] = footer;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== className || $[12] !== handleClickCardButton || $[13] !== pageHref || $[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t6 || $[18] !== testId || $[19] !== variant) {
    t7 = <BaseCardButton testId={testId} onClick={handleClickCardButton} variant={variant} className={className} href={pageHref} id={t3}>{t4}{t5}{t6}</BaseCardButton>;
    $[11] = className;
    $[12] = handleClickCardButton;
    $[13] = pageHref;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
    $[18] = testId;
    $[19] = variant;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};
export default Button;